import * as React from 'react'

import formatPrice from '../../../../../common/utils/formatPrice'

import * as styles from './price.module.css'

interface IProps {
  priceInCents: number
}

const Price = ({ priceInCents }: IProps) => {
  return <div className={styles.price}>${formatPrice(priceInCents)}</div>
}

export default Price
